export default "__VITE_ASSET__Cx4L5wAl__"